import { View } from './view'

export const Journal = View
